[
  {
    "version": "1.4.2",
    "date": "23/10/2026",
    "changes": [
      "Fix: Défini correctement la valeyr lorsqu'il n'y a pas de parent ID sélectionné à la création d'un utilisateur.",
      "Fix: Le token d'authentification se rafraichit automatiquement pour les connexions.",
      "Nouveau template de bannière pour les nouvelles releases",
      "Ajout d'un rôle spécifique pour modifier les app settings."
    ]
  },
  {
    "version": "1.4.1",
    "date": "19/10/2026",
    "changes": [
      "Fix: Ajout des App Settings pour une database nouvellement créée.",
      "Fix: Affichage des noms des parents lors de la création d'un utilisateur.",
      "Fix: Définition du mot de passe d'un utilisateur lors de la création d'un utilisateur."
    ]
  },
  {
    "version": "1.4.0",
    "date": "16/10/2026",
    "changes": [
      "Les bases de données avec une activité récente (<90j) sont tagguées dans les liste.",
      "Des tokens temporaires (30min) peuvent être créé pour un utilisateur.",
      "La recherche dans les group IDs supportent désormais les adresses emails et les INAMI.",
      "Le bandeau peut être modifier à partir du Cockpit (uniquement support)",
      "Les templates de bandeaux sont disponibles en un clic.",
      "L'import des formulaires dans les DBs a été supprimés (outdated)."
    ]
  },
  {
    "version": "1.3.1",
    "date": "08/09/2026",
    "changes": ["Fix: Affichage des dates de création des utilisateurs Free."]
  },
  {
    "version": "1.3.0",
    "date": "29/07/2026",
    "changes": [
      "Les bases de données et les utilisateurs bloqués sont tagués dans les listes.",
      "Les blocages et déblocages peuvent être effectués (uniquement compta).",
      "Les MS Light peuvent être activés ou désactivés (uniquement compta & vente)."
    ]
  },
  {
    "version": "1.2.1",
    "date": "23/07/2026",
    "changes": [
      "Les privilèges spéciaux sont corrigés avec le nouveau mode d'authentification."
    ]
  },
  {
    "version": "1.2.0",
    "date": "22/07/2026",
    "changes": [
      "Il n'est plus nécessaire d'introduire une clé UUID à la connexion pour accéder au Cockpit."
    ]
  },
  {
    "version": "1.1.1",
    "date": "28/06/2026",
    "changes": [
      "Montrer les group passwords des DBs de test ne requiert plus l'introduction d'une raison"
    ]
  },
  {
    "version": "1.1.0",
    "date": "26/06/2026",
    "changes": [
      "Accéder à un mot de passe DB requiert l'introduction d'une raison",
      "La création d'un AppSettings conserve les AppSettings déjà introduit",
      "Module d'opérations en batch ajouté pour les opérations sur de multiple DBs"
    ]
  },
  {
    "version": "1.0.36",
    "date": "06/03/2026",
    "changes": [
      "Ajout de la possibilité de créer des appSettings depuis le cockpit (Admin)",
      "Ajout de la possibilité d'uploader des formTemplates dans une db (En cours de développement)",
      "Dans la liste des appSettings, ajout de l'information sur le type d'appSettings (Crypté ou non crypté)"
    ]
  },
  {
    "version": "1.0.35",
    "date": "09/02/2026",
    "changes": [
      "Ajout du connexion mode dans le rapport getActivesFeaturesByGroupId"
    ]
  },
  {
    "version": "1.0.34",
    "date": "23/01/2026",
    "changes": [
      "Ajout du rapport getActivesFeaturesByGroupId qui affiche les fonctionnalités actives par groupe"
    ]
  },
  {
    "version": "1.0.33",
    "date": "15/12/2025",
    "changes": [
      "Authentification via token bearer",
      "Ajout de la possibilité d'uploader les codes d'assurance dans une db"
    ]
  },
  {
    "version": "1.0.32",
    "date": "31/10/2025",
    "changes": [
      "Ajout des colonnes exportées et du type d'export dans l'onglet reporting "
    ]
  },
  {
    "version": "1.0.31",
    "date": "30/10/2025",
    "changes": [
      "Ajout de la possibilité d'uploader les codes de référence dans une db",
      "Ajout de la possibilité d'uploader les codes du thésaurus dans une db",
      "Ajout de la possibilité d'uploader les tarifications dans une db",
      "Ajout de la possibilité d'uploader les mutuelles dans une db",
      "Modification du style des widgets",
      "Ajout de la langue de l'utilisateur dans l'export (Liste des licences)"
    ]
  },
  {
    "version": "1.0.30",
    "date": "01/10/2025",
    "changes": ["Ajout de la création d'un groupe depuis le cockpit"]
  }
]
